import { BorderedInput, Button, Typography } from '@navi/web-ui/lib/primitives';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { impersonateUser } from './action';
import { PARAMS_MAP_KEY } from '@cp/src/components/sidebar/SideNavigationPanel/utils';
import { LONGHORN_SESSION_TOKEN } from '../auth/constants/AuthConstants';
import { ImpersonationFormData } from './interface';
import { useDispatch } from 'react-redux';

const Impersonation = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<ImpersonationFormData>({
    mode: 'onSubmit',
    defaultValues: {
      identifier: ''
    }
  });

  const onSubmit = async (formData: ImpersonationFormData) => {
    try {
      setIsLoading(true);
      const payload = formData.identifier.includes('@')
        ? { email: formData.identifier }
        : { phoneNumber: formData.identifier };

      const response = await impersonateUser(payload);

      if (response?.data?.accessToken) {
        localStorage.removeItem(PARAMS_MAP_KEY);
        localStorage.setItem(LONGHORN_SESSION_TOKEN, response.data.accessToken);
        window.location.reload();
      } else {
        throw new Error('Invalid access token');
      }
    } catch (error: any) {
      toast.error(error?.message || 'Failed to impersonate user');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full h-full flex justify-center mt-8">
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="space-y-4">
          <Typography variant="h1">Debug User</Typography>

          <Controller
            name="identifier"
            control={control}
            rules={{
              required: 'Email or phone number is required',
              pattern: {
                value: /^([0-9]{10}|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})$/,
                message: 'Please enter a valid email or 10-digit phone number'
              }
            }}
            render={({ field }) => (
              <BorderedInput
                {...field}
                inputLabel="Email or Phone Number"
                placeholder="Enter email or phone number"
                className="w-[320px] h-[44px]"
                error={errors.identifier?.message}
              />
            )}
          />
        </div>

        <Button
          variant="primary"
          type="submit"
          className="w-[320px] h-[40px] mt-3"
          disabled={isLoading}
        >
          Log In
        </Button>
      </form>
    </div>
  );
};

export default Impersonation;
